package com.shreyasjoshi.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.models.PortfolioData

@Composable
fun ProjectsSection(isDarkMode: Boolean) {
    val projects = PortfolioData.projects

    Section(
        attrs = {
            id("projects")
            classNames(
                "portfolio-section",
                "py-16", "px-4", "sm:px-6", "lg:px-8", "max-w-6xl", "mx-auto", "border-b", "transition-colors",
                if (isDarkMode) "border-white/10" else "border-slate-200"
            )
        }
    ) {
        Div(attrs = { classNames("space-y-10") }) {
            // Header
            Div(attrs = { classNames("space-y-2") }) {
                Div(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "tracking-widest", "uppercase") }) {
                    Text("03 // PRODUCTION PROJECTS")
                }
                H2(
                    attrs = {
                        classNames(
                            "text-3xl", "font-bold", "tracking-tight",
                            if (isDarkMode) "text-white" else "text-slate-900"
                        )
                    }
                ) {
                    Text("Selected Automotive & Embedded Engineering Projects")
                }
                P(
                    attrs = {
                        classNames(
                            "text-sm", "max-w-3xl",
                            if (isDarkMode) "text-white/60" else "text-slate-600"
                        )
                    }
                ) {
                    Text("In-vehicle cockpit HMI systems, AOSP system service integration, Software-Defined Vehicle (SDV) over-the-air flows, and multi-region Android TV OTT launchers.")
                }
            }

            // Projects Grid
            Div(attrs = { classNames("grid", "grid-cols-1", "md:grid-cols-2", "gap-6") }) {
                projects.forEach { proj ->
                    Div(
                        attrs = {
                            classNames(
                                "p-6", "rounded-sm", "border", "flex", "flex-col", "justify-between", "transition-all",
                                if (isDarkMode) "bg-[#0a0a0a] border-white/10 hover:border-white/20"
                                else "bg-slate-50 border-slate-200 hover:border-slate-300"
                            )
                        }
                    ) {
                        Div(attrs = { classNames("space-y-4") }) {
                            // Top Meta Row
                            Div(attrs = { classNames("project-meta", "flex", "items-start", "justify-between", "gap-2") }) {
                                Div {
                                    H3(
                                        attrs = {
                                            classNames(
                                                "text-xl", "font-bold",
                                                if (isDarkMode) "text-white" else "text-slate-900"
                                            )
                                        }
                                    ) {
                                        Text(proj.title)
                                    }
                                    Div(
                                        attrs = {
                                            classNames(
                                                "text-xs", "font-medium", "mt-0.5",
                                                if (isDarkMode) "text-[#71C7EC]" else "text-sky-800"
                                            )
                                        }
                                    ) {
                                        Text("${proj.clientOrCompany} • ${proj.period}")
                                    }
                                }

                                Span(
                                    attrs = {
                                        classNames(
                                            "px-2", "py-0.5", "rounded-sm", "text-[10px]", "font-mono",
                                            if (isDarkMode) "bg-white/5 text-white/60 border border-white/10"
                                            else "bg-slate-200 text-slate-700 border border-slate-300"
                                        )
                                    }
                                ) {
                                    Text(proj.type)
                                }
                            }

                            // Summary
                            P(
                                attrs = {
                                    classNames(
                                        "text-xs", "sm:text-sm", "leading-relaxed",
                                        if (isDarkMode) "text-white/70" else "text-slate-600"
                                    )
                                }
                            ) {
                                Text(proj.summary)
                            }

                            // Contributions List
                            Div {
                                Div(
                                    attrs = {
                                        classNames(
                                            "text-[11px]", "font-mono", "uppercase", "tracking-wider", "mb-2",
                                            if (isDarkMode) "text-white/40" else "text-slate-500"
                                        )
                                    }
                                ) {
                                    Text("Key Contributions:")
                                }
                                Ul(
                                    attrs = {
                                        classNames(
                                            "space-y-1.5", "text-xs",
                                            if (isDarkMode) "text-white/60" else "text-slate-600"
                                        )
                                    }
                                ) {
                                    proj.contributions.forEach { c ->
                                        Li(attrs = { classNames("flex", "items-start", "gap-2") }) {
                                            Span(attrs = { classNames("text-[#189AD3]", "font-bold") }) { Text("▸") }
                                            Span { Text(c) }
                                        }
                                    }
                                }
                            }
                        }

                        // Technology Stack Footer
                        Div(
                            attrs = {
                                classNames(
                                    "pt-4", "mt-6", "border-t", "flex", "flex-wrap", "gap-1.5",
                                    if (isDarkMode) "border-white/10" else "border-slate-200"
                                )
                            }
                        ) {
                            proj.technologies.forEach { tech ->
                                Span(
                                    attrs = {
                                        classNames(
                                            "px-2", "py-0.5", "rounded-sm", "text-[10px]", "font-mono", "border",
                                            if (isDarkMode) "bg-white/5 border-white/10 text-white/60"
                                            else "bg-slate-100 border-slate-200 text-slate-700"
                                        )
                                    }
                                ) {
                                    Text(tech)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


